import React, { useState, useEffect, useContext } from 'react';
import MobileLogin from './MobileLogin.jsx';
import MailLogin from './MailLogin.jsx';
import { fetchGeneralSetting } from './Api';
import { Contextone } from './Context';

const NewLogin = () => {
  const [isEmailSetting, setEmailSetting] = useState(false);
  const [isMobileSetting, setMobileSetting] = useState(false);
  const [isLoginType, setLoginType] = useState('mobile'); // Default to 'mobile' login type
  const counterContext = useContext(Contextone);
  const isurl = counterContext.isDomain;
  const apiUrl = `https://${isurl}`;

  // Fetch general settings (email and mobile availability)
  useEffect(() => {
    const fetchSetting = async () => {
      try {
        const data = await fetchGeneralSetting(apiUrl);
        if (Array.isArray(data.result)) {
          data.result.forEach(setting => {
            if (setting.key === 'is_email' && setting.value === '1') {
              setEmailSetting(true);
            } else if (setting.key === 'is_mobile' && setting.value === '1') {
              setMobileSetting(true);
            }
          });
        }
      } catch (error) {
        console.error('Error fetching settings:', error);
      }
    };
    fetchSetting();
  }, [apiUrl]);

  // Switching between mobile and email login
  const handleSwitch = (type) => {
    setLoginType(type);
  };

  const handleShowContent = (type) => {
    if (type === 'mail') {
        counterContext.setSwitchEmail(true);
    } else if (type === 'mobile') {
        counterContext.setSwitchEmail(false);
    }
  };

  return (
    <div>
      
      {isEmailSetting && isMobileSetting && !counterContext.isSwitchEmail && <MobileLogin handleShowContent={handleShowContent}/>}
      {isEmailSetting && isMobileSetting && counterContext.isSwitchEmail && <MailLogin handleShowContent={handleShowContent}/>}
      
      {!isEmailSetting && isMobileSetting && <MobileLogin />}
      {!isMobileSetting && isEmailSetting && <MailLogin />}
    </div>
  );
};

export default NewLogin;
